import { html } from "lit";
var icon_dashboard_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M12 18a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2v-6a2 2 0 012-2h6zm14 0a2 2 0 012 2v6a2 2 0 01-2 2h-6a2 2 0 01-2-2v-6a2 2 0 012-2h6zm-14 2H6v6h6v-6zm14 0h-6v6h6v-6zM12 4a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h6zm14 0a2 2 0 012 2v6a2 2 0 01-2 2h-6a2 2 0 01-2-2V6a2 2 0 012-2h6zM12 6H6v6h6V6zm14 0h-6v6h6V6z"
      fill-rule="nonzero" />
  </svg>
`;
export {
  icon_dashboard_default as default
};
//# sourceMappingURL=icon-dashboard.js.map
